import { FadeUp, Overline, MaskedLines } from "@/components/Reveal";
import { STEPS } from "@/data/site";

export default function Workflow() {
  return (
    <section id="workflow" data-testid="workflow-section" className="py-28 md:py-40">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12">
        <FadeUp>
          <Overline>How It Works</Overline>
        </FadeUp>
        <h2 className="mt-8 font-display font-light text-4xl md:text-5xl lg:text-7xl leading-[0.98] tracking-tight">
          <MaskedLines lines={["SIMPLE FOR YOU.", "PRECISE FOR US."]} />
        </h2>

        <div className="mt-16 md:mt-24 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {STEPS.map((s, i) => (
            <FadeUp key={s.num} delay={0.12 * i}>
              <div data-testid={`workflow-step-${s.num}`} className="border-l hairline pl-6 md:pl-8 group">
                <span className="font-display text-5xl md:text-6xl font-light text-ivory/15 group-hover:text-gold/40 transition-colors duration-500">
                  {s.num}
                </span>
                <h3 className="mt-6 text-xs uppercase tracking-[0.35em] text-ivory">{s.title}</h3>
                <p className="mt-4 text-sm text-muted font-light leading-relaxed">{s.desc}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
